import React, { useState, useEffect } from 'react'
import NavBar from '../component/NavBar'

function Home() {
  const [currentSlide, setCurrentSlide] = useState(0)

  const carouselImages = [
    {
      src: '/c1.jpg',
      alt: 'Shehala Foundation Image 1',
    },
    {
      src: '/c2.jpg',
      alt: 'Shehala Foundation Image 2',
    },
    {
      src: '/c3.jpg',
      alt: 'Shehala Foundation Image 3',
    },
    {
      src: '/c4.jpg',
      alt: 'Shehala Foundation Image 4',
    },
    {
      src: '/c5.jpg',
      alt: 'Shehala Foundation Image 5',
    },
  ]

  useEffect(() => {
    const interval = setInterval(() => {
      setCurrentSlide((prev) => (prev + 1) % carouselImages.length)
    }, 5000)
    return () => clearInterval(interval)
  }, [carouselImages.length])

  const goToSlide = (index) => {
    setCurrentSlide(index)
  }

  const goToPrevSlide = () => {
    setCurrentSlide((prev) => (prev - 1 + carouselImages.length) % carouselImages.length)
  }

  const goToNextSlide = () => {
    setCurrentSlide((prev) => (prev + 1) % carouselImages.length)
  }

  return (
    <div className="min-h-screen bg-gray-50">
      <NavBar />

      {/* Carousel */}
      <section className="relative w-full h-52 md:h-80 overflow-hidden">
        {carouselImages.map((image, index) => (
          <div
            key={index}
            className={`absolute inset-0 transition-opacity duration-700 ease-in-out ${
              index === currentSlide ? 'opacity-100' : 'opacity-0'
            }`}
          >
            <img
              src={image.src}
              alt={image.alt}
              className="w-full h-full object-cover"
            />
            <div className="absolute inset-0 bg-black bg-opacity-40"></div>
          </div>
        ))}

        {/* Previous Button */}
        <button
          onClick={goToPrevSlide}
          className="absolute left-4 top-1/2 transform -translate-y-1/2 bg-white bg-opacity-80 hover:bg-opacity-100 rounded-full p-2 transition duration-300"
        >
          <svg className="w-6 h-6 text-gray-800" fill="none" stroke="currentColor" viewBox="0 0 24 24">
            <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M15 19l-7-7 7-7" />
          </svg>
        </button>

        {/* Next Button */}
        <button
          onClick={goToNextSlide}
          className="absolute right-4 top-1/2 transform -translate-y-1/2 bg-white bg-opacity-80 hover:bg-opacity-100 rounded-full p-2 transition duration-300"
        >
          <svg className="w-6 h-6 text-gray-800" fill="none" stroke="currentColor" viewBox="0 0 24 24">
            <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M9 5l7 7-7 7" />
          </svg>
        </button>

        {/* Dots */}
        <div className="absolute bottom-4 left-1/2 transform -translate-x-1/2 flex gap-2">
          {carouselImages.map((_, index) => (
            <button
              key={index}
              onClick={() => goToSlide(index)}
              className={`w-3 h-3 rounded-full transition duration-300 ${
                index === currentSlide ? 'bg-white' : 'bg-white bg-opacity-50'
              }`}
            />
          ))}
        </div>
      </section>

      {/* Hero Section */}
      <section className="relative bg-gradient-to-r from-gray-800 to-gray-900 text-white py-12 md:py-16">
        <div className="container mx-auto px-4 text-center">
          <h1 className="text-3xl md:text-5xl font-bold mb-4">
            Shehala Foundation
          </h1>
          <p className="text-lg md:text-2xl mb-4 opacity-90">
            Compassionate Healthcare, Orphanage, Social support for the needy
          </p>
          <div className="w-24 md:w-48 h-1 opacity-40 bg-white mx-auto mb-6 md:mb-8"></div>
          <p className="text-base md:text-lg mb-8 opacity-90 text-left md:text-center max-w-4xl mx-auto px-4">
           Shehala Foundation is a nonprofit charitable organization established in May 2011. The foundation provides free outdoor healthcare services and financial support to underprivileged communities, including Murong tribe orphans, with support from Shehala IT Limited and other generous donors. Recognizing our social responsibility toward disadvantaged communities, we initiated free outdoor healthcare clinics for the most vulnerable and helpless individuals. Our work goes beyond medical treatment — we provide care, compassion, and dignity to those in need. The foundation is also deeply committed to supporting orphans. We ensure their healthcare, nutrition, and access to primary education, helping them build a healthier and more secure future. We carry a strong vision for our philanthropic work. Although this journey began with limited resources, it marks the beginning of a long-term commitment to serving humanity. We warmly invite compassionate individuals and generous donors to connect with Shehala Foundation and support our efforts to uplift those in need. Since its inception, Shehala Foundation has provided healthcare services to over 5,500 men, women, and children, and has supported 99 orphans to date.
          </p>
          <div className="flex flex-wrap justify-center gap-4">
            {/* <a
              href="/contact"
              className="bg-white text-gray-800 px-8 py-3 rounded-lg font-semibold hover:bg-gray-200 transition duration-300"
            >
              Get Free Care
            </a> */}
            <a
              href="/donate"
              className="border-2 border-white text-white px-8 py-3 rounded-lg font-semibold hover:bg-white hover:text-gray-800 transition duration-300"
            >
              Donate Now
            </a>
          </div>
        </div>
      </section>

      {/* Services Section */}
      <section className="py-16 bg-white">
        <div className="container mx-auto px-4">
          <h2 className="text-3xl font-bold text-center text-gray-800 mb-12">
            Our Free Services
          </h2>
          <div className="grid grid-cols-1 md:grid-cols-3 gap-8">
            {/* Service 1 */}
            <div className="text-center p-6 rounded-xl shadow-lg bg-gray-50 hover:shadow-xl transition duration-300">
              <div className="w-16 h-16 mx-auto mb-4 bg-gray-200 rounded-full flex items-center justify-center">
                <svg className="w-8 h-8 text-gray-700" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                  <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M4.318 6.318a4.5 4.5 0 000 6.364L12 20.364l7.682-7.682a4.5 4.5 0 00-6.364-6.364L12 7.636l-1.318-1.318a4.5 4.5 0 00-6.364 0z" />
                </svg>
              </div>
              <h3 className="text-xl font-semibold text-gray-800 mb-2">Outpatient Diagnostic Center</h3>
              <p className="text-gray-600">
                Comprehensive health checkups, screenings, Counseling and treatment for common illnesses under a registered doctor.
              </p>
            </div>

            {/* Service 2 */}
            <div className="text-center p-6 rounded-xl shadow-lg bg-gray-50 hover:shadow-xl transition duration-300">
              <div className="w-16 h-16 mx-auto mb-4 bg-gray-200 rounded-full flex items-center justify-center">
                <svg className="w-8 h-8 text-gray-700" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                  <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M9 12l2 2 4-4m6 2a9 9 0 11-18 0 9 9 0 0118 0z" />
                </svg>
              </div>
              <h3 className="text-xl font-semibold text-gray-800 mb-2">Pathology, Ultrasound, ECG </h3>
              <p className="text-gray-600">
                Pathology including blood tests, urine tests, and other diagnostic procedures plus Coloured Ultra-sound and ECG (Electrocardiogram) at a nominal fee.
              </p>
            </div>

            {/* Service 3 */}
            <div className="text-center p-6 rounded-xl shadow-lg bg-gray-50 hover:shadow-xl transition duration-300">
              <div className="w-16 h-16 mx-auto mb-4 bg-gray-200 rounded-full flex items-center justify-center">
                <svg className="w-8 h-8 text-gray-700" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                  <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M12 6.253v13m0-13C10.832 5.477 9.246 5 7.5 5S4.168 5.477 3 6.253v13C4.168 18.477 5.754 18 7.5 18s3.332.477 4.5 1.253m0-13C13.168 5.477 14.754 5 16.5 5c1.747 0 3.332.477 4.5 1.253v13C19.832 18.477 18.247 18 16.5 18c-1.746 0-3.332.477-4.5 1.253" />
                </svg>
              </div>
              <h3 className="text-xl font-semibold text-gray-800 mb-2">Free medicine</h3>
              <p className="text-gray-600">
                Free medicine distribution to the needy and vulnerable groups.
              </p>
            </div>
          </div>
        </div>
      </section>

      {/* About Section */}
      <section className="py-16 bg-gray-50">
        <div className="container mx-auto px-4">
          <div className="flex flex-wrap items-center gap-12">
            <div className="flex-1 min-w-[300px]">
              <h2 className="text-3xl font-bold text-gray-800 mb-6">
                About Shehala Foundation
              </h2>
              <p className="text-gray-600 mb-4">
                Founded with a vision of accessible healthcare for vulnerable communities, Shehala Foundation
                has been serving our community since its inception. We believe that quality
                healthcare is a fundamental human right, not a privilege.
              </p>
              <p className="text-gray-600 mb-6">
                Our team of dedicated doctors, nurses, and volunteers work tirelessly to
                provide comprehensive healthcare services to those who need them most. We also contribute to an orphange at remote hilly region of Bangladesh.
                With the support of our generous donors and partners, we continue to expand our reach and impact.
              </p>
              <a
                href="/about"
                className="inline-block bg-gray-700 text-white px-6 py-3 rounded-lg font-semibold hover:bg-gray-800 transition duration-300"
              >
                Learn More About Us
              </a>
            </div>
            <div className="flex-1 min-w-[300px]">
              <div className="bg-white p-8 rounded-xl shadow-lg">
                <div className="grid grid-cols-2 sm:grid-cols-4 gap-6 text-center">
                  <div>
                    <p className="text-4xl font-bold text-gray-700">5000+</p>
                    <p className="text-gray-600">Patients Served</p>
                  </div>
                  <div>
                    <p className="text-4xl font-bold text-gray-700">20+</p>
                    <p className="text-gray-600">Volunteer Doctors</p>
                  </div>
                  <div>
                    <p className="text-4xl font-bold text-gray-700">15+</p>
                    <p className="text-gray-600">Years of Service</p>
                  </div>
                  <div>
                    <p className="text-4xl font-bold text-gray-700">100%</p>
                    <p className="text-gray-600">Free Services</p>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>

      {/* How You Can Help */}
      <section className="py-16 bg-white">
        <div className="container mx-auto px-4">
          <h2 className="text-3xl font-bold text-center text-gray-800 mb-12">
            How You Can Help
          </h2>
          <div className="grid grid-cols-1 md:grid-cols-2 gap-8 max-w-4xl mx-auto">
            <div className="bg-gray-50 p-8 rounded-xl border-l-4 border-gray-700">
              <h3 className="text-xl font-semibold text-gray-800 mb-3">
                Donate
              </h3>
              <p className="text-gray-600 mb-4">
                Your contributions help us purchase medical supplies, equipment,
                and fund our free clinic operations.
              </p>
              <a
                href="/donate"
                className="text-gray-700 font-semibold hover:text-gray-800"
              >
                Make a Donation →
              </a>
            </div>
            <div className="bg-gray-50 p-8 rounded-xl border-l-4 border-gray-700">
              <h3 className="text-xl font-semibold text-gray-800 mb-3">
                Volunteer
              </h3>
              <p className="text-gray-600 mb-4">
                Join our team of dedicated volunteers and make a difference
                in someone's life today.
              </p>
              <a
                href="/volunteer"
                className="text-gray-700 font-semibold hover:text-gray-800"
              >
                Become a Volunteer →
              </a>
            </div>
          </div>
        </div>
      </section>

      {/* Contact CTA */}
      <section className="py-16 bg-gray-800 text-white">
        <div className="container mx-auto px-4 text-center">
          <h2 className="text-3xl font-bold mb-4">
            Want to become a part of our mission?
          </h2>
          <p className="text-xl opacity-90 mb-8 max-w-2xl mx-auto">
            Don't let your geographical location or financial constraints
            prevent you from making a difference.
          </p>
          <a
            href="/contact"
            className="inline-block bg-white text-gray-800 px-8 py-3 rounded-lg font-semibold hover:bg-gray-200 transition duration-300"
          >
            Contact Us Today
          </a>
        </div>
      </section>

      {/* Footer */}
      <footer className="bg-gray-800 text-white py-8">
        <div className="container mx-auto px-4 text-center">
          <p className="opacity-80">
            © {new Date().getFullYear()} Shehala Foundation. All rights reserved.
          </p>
          <p className="opacity-60 text-sm mt-2">
            A Compassion-Driven Approach to Corporate Social Responsibility
          </p>
        </div>
      </footer>
    </div>
  )
}

export default Home
